export default {
  'pages.entryRegistration.title': '出入登记',
  'pages.entryRegistration.breadcrumb.person': '人员管理',
  'pages.entryRegistration.breadcrumb.entryRegistration': '出入登记',
  
  // 过滤器
  'pages.entryRegistration.filter.registrationType': '登记类型',
  'pages.entryRegistration.filter.status': '状态',
  
  // 登记类型
  'pages.entryRegistration.type.guest': '访客登记',
  'pages.entryRegistration.type.moveout': '搬出登记',
  'pages.entryRegistration.type.decoration': '装修报备',
  
  // 状态
  'pages.entryRegistration.status.all': '全部',
  'pages.entryRegistration.status.registered': '已登记',
  'pages.entryRegistration.status.in_progress': '进行中',
  'pages.entryRegistration.status.completed': '已完成',
};
